import _ from 'underscore'
import makeRpcCall from '../jquery_rpc'
import RpcError from './RpcError'
import {batched, batchedPromise} from '../../redux/batch'

// global storage of current rpc calls
let rpcCalls = {}

/**
 *
 * Perform rpc call and return promise function
 *
 * @param method
 * @param params
 * @param customHandler handler if need to prevent default error handler
 * @param abortKey string key
 *                 used to identify running rpcCall, by this key you can abort request
 *                 if key is null - request can not be aborted
 *                 default value equals name of requested method
 * @returns {Promise}
 */
export const rpcCall = (method, params, customHandler = (error) => null, abortKey = method) => {
    if (abortKey)
        abortCall(abortKey)

    return new Promise((resolve, reject) => {
        const call = makeRpcCall(
            method,
            params,
            (data) => {
                if (abortKey)
                    _removeCall(abortKey)
                resolve(data)
            },
            (jqXHR, textStatus, errorThrown) => {
                if (abortKey)
                    _removeCall(abortKey)

                // create error
                const error = new RpcError(jqXHR, textStatus, errorThrown)
                // TODO: get rid of legacy custome handler behavior - don't rely on it returning true/false
                const isHandled_legacy = customHandler(error);
                if (error.isHandled()) {
                    reject(error.getNewError() !== null ? error.getNewError() : error)
                    return true
                } else {
                    reject(error)
                    return isHandled_legacy
                }
            })

        if (abortKey)
            _addCall(abortKey, call)
    })
}

const _addCall = (abortKey, call) => {
    rpcCalls[abortKey] = call
}

const _removeCall = (abortKey) => {
    rpcCalls = _.omit(rpcCalls, abortKey)
}

/**
 * Abort rpc call by key
 * @param abortKey
 */
export const abortCall = (abortKey) => {
    const call = rpcCalls[abortKey]
    if (call) {
        call.abort()
        _removeCall(abortKey)
    }
}

/**
 * Version of 'rpcCall' with enabled redux batching.
 * Use it instead of standard 'rpcCall' if you want to enable batching in result promise.
 * @returns {BatchPromiseWrapper}
 */
export function batchedRpcCall(method, params, customHandler = () => null, abortKey) {
    return batchedPromise(rpcCall(method, params, batched(customHandler), abortKey))
}

export default rpcCall



// WEBPACK FOOTER //
// ./web/js/util/rpc/rpcCalls.js